module.exports = __webpack_public_path__ + "static/johnMehak.6790e967.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/johnMehak.png
// module id = 469
// module chunks = 76778261247453